import axios from 'axios';

// 上传文件
export function uploadFile(option) {
    axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
    return axios.post('/system/file/cropper-upload', option, { encode: true });
}
// 纷享号信息
export function teamInfo(option) {
    return axios.get('/knowledge-operation/come-enjoy/get-comeenjoy-brief-info', { params: option });
}

// 业务累计信息
export function teamTrend(option) {
    return axios.get('/knowledge-operation/come-enjoy/get-comeenjoy-business-trend', { params: option });
}

// 账号列表
export function teamAccounts(option) {
    return axios.get('/knowledge-operation/come-enjoy/get-enjoylist-for-user', { params: option });
}

// 运营数据
export function teamOperationData(option) {
    return axios.get('/knowledge-operation/come-enjoy/get-analysis', { params: option });
}
// 纷享管理首页 内容列表
export function creationContent(option) {
    return axios.get('/knowledge-operation/come-enjoy/come-enjoy-manage-question', { params: option });
}

// 纷享管理首页 内容列表删除
export function creationContentDelete(option) {
    return axios.delete(`/knowledge-operation/question-manage/remove/${option.id}`);
}
// 纷享管理首页 内容列表激活
export function creationContentActive(option) {
    return axios.put(`/knowledge-operation/question-manage/active/${option.id}`);
}

// 纷享管理首页 内容列表关闭
export function creationContentClose(option) {
    return axios.put(`/knowledge-operation/question-manage/close/${option.id}`);
}

// 获取内容详情
export function contentDetail(option) {
    return axios.get('/knowledge-operation/question/find-question-by-id', { params: option });
}

// 获取关联专栏
export function connectList(option) {
    return axios.get('/knowledge-operation/special-column/enjoy-column-basic-info', { params: option });
}

// 删除时取消关联
export function deleteConnect(option) {
    return axios.put('/knowledge-operation/special-column/release-question', option, { encode: true });
}

// 创作上传
export function creationUpload(option) {
    return axios.post('/knowledge-operation/question', option, { encode: true, loading: true });
}

// 创作修改
export function creationModify(option) {
    return axios.put('/knowledge-operation/question', option, { encode: true });
}

// 是否开启审核
export function needCheck() {
    return axios.get('/knowledge-operation/action/get-audit-status', { loading: true });
}

// 专栏新增
export function columnUpload(option) {
    return axios.post('/knowledge-operation/special-column', option, { encode: true });
}

// 修改专栏请求详细
export function editColumnDetail(option) {
    return axios.get(`/knowledge-operation/special-column/get-complete-info/${option.id}`);
}

// 专栏修改
export function columnModify(option) {
    return axios.put(`/knowledge-operation//special-column/${option.id}`, option, { encode: true });
}

// 专栏删除
export function columnDelete(option) {
    return axios.delete(`/knowledge-operation/special-column/${option.id}`);
}

// 专栏详情
export function columnDetail(option) {
    return axios.get(`/knowledge-operation/special-column/${option.id}`, { loading: true });
}

// 专栏目录
export function columnDirectory(option) {
    return axios.get(`/knowledge-operation/special-column/column-contents/${option.id}`, {
        params: { sort: option.sort, page: option.page, pageSize: option.pageSize, isEnjoyAdmin: option.isEnjoyAdmin },
    });
}

// 专栏内容
export function columnContent(option) {
    return axios.get('/knowledge-operation/special-column/enjoy-column/', { params: option });
}

// 专栏关联内容列表
export function columnConnectList(option) {
    return axios.get('/knowledge-operation/question/column-question', { params: option });
}

// 发布时敏感检测 length>0 有敏感词汇
export async function sensitiveDetect(option, vue) {
    const { data: sensitives } = await axios.post('/system/sensitive/judge-str', option, { encode: true, loading: true });
    if (sensitives.length > 0) {
        vue.$notification.error({
            message: `您提交的内容包含敏感词汇：${sensitives.join(',')};请修改后重新提交！`,
        });
        return true;
    }
    return false;
}
